export default __webpack_public_path__ + "static/media/yo1.880aa03c.png";